import React, { useEffect, useState } from "react";
import axios from "../../axiosinstens";
import { environment } from "../../environment";

function Section2() {
  const [allsettings, setSettings] = useState([]);
  const getSettings = async () => {
    const response = await axios.get("getSetting");
    setSettings(response.data.settings);
  };

  useEffect(() => {
    getSettings();
  }, []);

  return (
    <>
      <div className="evn">
        <h2>
          <span>About</span> Spectacular Seminars
        </h2>
        <hr />
      </div>
      {allsettings.about_heading && allsettings.about_desc && (
        <section className="about_uss">
          <div className="aboutall">
            <div className="about_left">
              <div className="aboutimmg">
                <img
                  src={`${environment.imageBaseURL}about_image/${allsettings.about_image}`}
                  alt="About Top"
                />
              </div>
            </div>
            <div className="about_left">
              <div className="aboutxts">
                <div className="abouright">
                  <h2>{allsettings.about_heading}</h2>
                  <p>
                    {allsettings.about_desc.split("\n").map((line, index) => (
                      <span key={index}>
                        {line}
                        <br />
                      </span>
                    ))}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
}

export default Section2;
